/**
 * Parked Domain Display Formatting Utilities
 *
 * Provides consistent text formatting for parked domain fields across table and drawer.
 */

/**
 * Format parked category for display
 * - none -> Not Parked
 * - All others -> Capitalize first letter
 */
export function formatParkedCategory(
  category: string | undefined | null
): string {
  if (!category || category === 'none') {
    return 'Not Parked';
  }

  // Capitalize first letter
  return category.charAt(0).toUpperCase() + category.slice(1).toLowerCase();
}

/**
 * Format status for display
 * Capitalizes each hyphen-separated segment while preserving hyphens
 * - available -> Available
 * - in-use -> In-Use
 * - burned -> Burned
 */
export function formatStatus(status: string | undefined | null): string {
  if (!status) return '-';

  // Capitalize each hyphen-separated segment, preserve hyphen
  return status
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('-');
}

/**
 * Format Cloudflare status for display
 * Capitalizes the status text
 * - active -> Active
 * - pending -> Pending
 */
export function formatCloudflareStatus(
  status: string | undefined | null
): string {
  if (!status) return '-';

  // Capitalize first letter
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}
